import { html } from 'lit';
import { SlidersHorizontal } from 'lucide-static';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { state } from 'lit/decorators.js';
import { pdsCustomIconElement as customElement } from '../../../decorators/pds-icon';
import { PdsIcon } from '../PdsIcon';

@customElement('pds-icon-sliders-horizontal')
export class PdsIconSlidersHorizontal extends PdsIcon {
  @state()
  icon = SlidersHorizontal;

  render() {
    return html`${unsafeHTML(this.setIconAttributes())}`;
  }
}
